module.exports = __webpack_public_path__ + "static/media/OpenSans-LightItalic.c147d130.ttf";